package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.customer_card_tab.component.customer_card_transactions

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.HorizontalScrollBehavior

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.TransactionColumnsEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.filtered_transaction.FilteredLoyaltyCardItem
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CircleIcon
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.HeaderTitle
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun CustomerCardTransaction(
    windowSizeMode: WindowSizeModeEnum,
    selectedTransactionColumns: Set<TransactionColumnsEnum>,
    filteredLoyaltyCards: List<FilteredLoyaltyCardItem?>?,
    showTransactionColumnsDialog: () -> Unit,
)
{


    Column(
        modifier = Modifier
            .fillMaxWidth()
            .borderRadius(Dimen.lowBorderRadius)
    )
    {
        Row(
            modifier = Modifier
                .fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        )
        {
            MediumContentTitle(
                title = Strings.current().transaction
            )

            Spacer()

            CustomIcon(
                icon = Res.PathIcon.appsMenu,
                onIconClick = {
                    showTransactionColumnsDialog()
                }
            )
        }


        Column(
            modifier = HorizontalScrollBehavior.toModifier()
                .fillMaxWidth()
                .border(
                    width = Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.ActionDisabledBackground.rgb
                )
                .borderRadius(Dimen.lowBorderRadius)
        ) {

            Row(
                modifier = HorizontalScrollBehavior.toModifier()
                    .fillMaxWidth()
                    .thenIf(
                        windowSizeMode!= WindowSizeModeEnum.Desktop,
                        Modifier.width(Dimen.maxWidth)
                    )
                    .overflow(Overflow.Auto)
                    .height(Dimen.gridHeaderHeight)
                    .borderBottom(
                        width = Dimen.smallThickness,
                        style = LineStyle.Solid,
                        color = Theme.ActionDisabledBackground.rgb
                    )
                    .backgroundColor(Theme.ActionHover.rgb)
                    .padding(leftRight = Dimen.normalPadding),
                verticalAlignment = Alignment.CenterVertically
            ) {
                selectedTransactionColumns.forEach {
                    HeaderTitle(
                        title = it.title,
                        fillMaxWidth = true,
                    )
                }

            }

            Column(
                modifier = VerticalScrollBehavior.toModifier()
                    .height(Dimen.kitchenInfoItemsHeight)
                    .fillMaxWidth()
            )
            {
                filteredLoyaltyCards?.forEach {
                    //TODO(MUST BE COMPLETED)
                }
            }


        }




    }
}